module.exports = __webpack_public_path__ + "img/tu03.16e5b072.png";